import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useMemo, useState } from 'react';
import { InfoDialog } from './InfoDialog';
import { InfoDialogContext } from './infoDialogContext';
export const InfoDialogProvider = ({ children }) => {
    const [open, setOpen] = useState(false);
    const [props, setProps] = useState({});
    const { onOk, ...rest } = props;
    const handleOk = useCallback(() => {
        setOpen(false);
        onOk?.();
    }, [onOk]);
    const handleClose = useCallback(() => {
        setOpen(false);
    }, []);
    const contextValue = useMemo(() => ({ setOpen, props, setProps }), [setOpen, props, setProps]);
    return (_jsxs(InfoDialogContext.Provider, { value: contextValue, children: [children, _jsx(InfoDialog, { ...rest, open: open, onClose: handleClose, onOk: handleOk })] }));
};
//# sourceMappingURL=InfoDialogProvider.js.map